import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AmenityWithCount, Property, PropertyRequest } from "../../types/Property"
import { addProperty, deleteProperty, fetchProperties, fetchPropertyById, updateProperty } from "../thunks/property"

export interface PropertyState{
    properties: Property[];
    loading: boolean;
    error?: any;
    amenities?: AmenityWithCount[];
    response?: any;
    property?: Property;
    updateError?: any;
    updateResponse?: any;
    updateLoading?: boolean;
    deleteResponse?: any;
    deleteError?: any;
    deleteLoading?: boolean;
    images: File[];
    showEvent: boolean;
    showForm: boolean;
}

const state : PropertyState = {
    properties: [],
    loading: false,
    error: null,
    amenities: [],
    response: null,
    property: undefined,
    updateError: null,
    updateResponse: null,
    updateLoading: false,
    deleteResponse: null,
    deleteError: null,
    deleteLoading: false,
    images: [],
    showEvent: false,
    showForm: false,
}

// Actions
export const loadAmenities = createAction('LOAD_AMENITIES', function prepare(amenities: AmenityWithCount[]) {
  return(
    {
      payload: amenities
    }
  )
});

const propertySlice = createSlice({
    name: 'property',
    initialState: state,
    reducers: {
      // standard reducer logic, with auto-generated action types per reducer
      loadImages: (state, action: PayloadAction<File[]>)=>{
        return{
          ...state,
          images: action.payload
        }
      },
      resetDeleteResponse: (state) => {
        state.deleteResponse = null
      },
      SetShowEvent:(state, action:PayloadAction<boolean>)=> {
          state.showEvent= action.payload;
      },
      SetShowForm:(state, action:PayloadAction<boolean>)=> {
        state.showForm= action.payload;
    }
      
    },
    extraReducers: (builder) => {
        builder.addCase(loadAmenities, (state, action)=>{
          state.amenities = action.payload;
        })
        builder.addCase(fetchProperties.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.properties = payload;
            state.error = null;
        })
        builder.addCase(fetchProperties.pending, (state, action) => {
          state.loading = true;
        })
        builder.addCase(fetchProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error
        })
        
        builder.addCase(addProperty.fulfilled, (state, { payload }) => {
          state.loading = false;
          state.response = payload;
          state.error = null;
        })
        builder.addCase(addProperty.pending, (state, action) => {
          state.loading = true;
          state.response = null;
        })
        builder.addCase(addProperty.rejected, (state, action) => {
            state.loading = false;
            state.response = null;
            state.error = action.error
        })

        builder.addCase(fetchPropertyById.fulfilled, (state, { payload }) => {
          state.loading = false;
          state.property = payload;
          state.error = null;
        })
        builder.addCase(fetchPropertyById.pending, (state, action) => {
          state.loading = true;
        })
        builder.addCase(fetchPropertyById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error
        })

        builder.addCase(updateProperty.fulfilled, (state, { payload }) => {
          state.updateLoading = false;
          state.updateResponse = true;
          state.updateError = null;
        })
        builder.addCase(updateProperty.pending, (state, action) => {
          state.updateLoading = true;
          state.updateResponse = null;
        })
        builder.addCase(updateProperty.rejected, (state, action) => {
            state.updateLoading = false;
            state.updateResponse = null;
            state.updateError = action.error
        })

        builder.addCase(deleteProperty.fulfilled, (state, { payload }) => {
          state.deleteLoading = false;
          state.deleteResponse = true;
          state.deleteError = null;
        })
        builder.addCase(deleteProperty.pending, (state, action) => {
          state.deleteLoading = true;
          state.deleteResponse = null;
        })
        builder.addCase(deleteProperty.rejected, (state, action) => {
            state.deleteLoading = false;
            state.deleteResponse = null;
            state.deleteError = action.error
        })
      },
      
})
export const { loadImages, resetDeleteResponse, SetShowEvent, SetShowForm } = propertySlice.actions;
const propertyReducer = propertySlice.reducer;
export default propertyReducer